export default __webpack_public_path__ + "static/media/9Lottologo.1a0f69de.png";